<template>
  <div class="container">
    <div class="about-banner">
      <img src="../../assets/images/banner-5.jpg" />
      <p class="title">{{ t('Companyname') }}</p>
      <p class="subtitle">{{ t('aboutc.bannertitle') }}</p>
      <!-- <span class="learn-btn">{{ t('learnmore') }}
        <el-icon class="topright-btn" :size="20">
          <TopRight />
        </el-icon>
      </span> -->
    </div>
    <div class="navigation-bar">
      <div class="navigation-bar-txt">
        <span><router-link to="/">{{ t('menu.home') }}</router-link></span>
        <span>{{ t('menu.about') }}</span>
      </div>
    </div>
    <div class="new-list-bar">
      <div class="news-wraper">
        <img src="../../assets/images/gy-2.jpg" />
        <div class="news-right-wraper">
          <h2 class="news-right-title">{{ t('aboutservice.title1') }}</h2>
          <p class="news-right-subtitle">{{ t('aboutservice.title1txt') }}</p>
        </div>
      </div>
    </div>
    <div class="new-list-bar bg-new-list">
      <img src="../../assets/images/gy-3.jpg" />
      <div class="text-bar">
        <h2 class="title">{{ t('aboutservice.title2') }}</h2>
        <p class="subtitle">{{ t('aboutservice.title2txt') }}</p>
      </div>
    </div>
    <div class="new-list-bar" style="text-align: center;">
      <h2 class="title">{{ t('aboutservice.title3') }}</h2>
      <ul class="serviceList">
        <li v-for="(item, index) in serviceList" :key="item" :class="getClass(index, item)"
          @mouseover="handleMouseOver(index)">
          <img class="service-img" :src="item.qrcode" />
          <div class="appscene">
            <div class="learn-txt">
              {{ item.name }}
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="new-list-bar" style="text-align: center;">
      <h2 class="title">{{t('menu.service')}}</h2>
      <ul class="serviceUIList">
        <li v-for="(item, index) in ourserviceList" :key="item" :class="getClass(index, item)">
          <img class="service-img" :src="item.qrcode" />
          <div class="appscene" v-if="item.name!=''">
            <div class="learn-txt" :style="{textIndent:locale==='ru'?'50px':'150px'}" v-for="(ite, index) in t(item.name).split(';')" :key="index">
              {{ ite }}
            </div>
          </div>
          <div class="appscene" v-else >
            <div class="learn-txt">{{t(item.name)}}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup>
import { ref, watch} from "vue";
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()
const serviceList = ref([])
const serviceList_cn = ref([
  {
    isActive: false,
    qrcode: require("../../assets/images/zl-z-1.png"),
    name: '高端转盘挤奶机',
  },
  {
    isActive: false,
    qrcode: require("../../assets/images/zl-z-2.png"),
    name: '半地下式并列式挤奶机',
  },
  {
    isActive: false,
    qrcode: require("../../assets/images/zl-z-3.png"),
    name: '智能分群称重系统',

  },
  {
    isActive: false,
    qrcode: require("../../assets/images/zl-z-4.png"),
    name: '下箱全封闭式并列挤奶机',
  }
])
const serviceList_en = ref([
  {
    isActive: false,
    qrcode: require("../../assets/images/zl-z-1.png"),
    name: 'Heavy-duty rotary milking platform system',
  },
  {
    isActive: false,
    qrcode: require("../../assets/images/zl-z-3.png"),
    name: 'Parallel milking system',

  },
  {
    isActive: false,
    qrcode: require("../../assets/images/zl-z-4.png"),
    name: 'Intelligent grouping &weighing system',
  }
])
const serviceList_ru = ref([
  {
    isActive: false,
    qrcode: require("../../assets/images/zl-z-1.png"),
    name: 'Современная карусельная доильная установка',
  },
  {
    isActive: false,
    qrcode: require("../../assets/images/zl-z-3.png"),
    name: 'Интеллектуальная система сортировки и взвешивания',

  },
  {
    isActive: false,
    qrcode: require("../../assets/images/zl-z-4.png"),
    name: 'Параллельная доильная установка',
  }
])
// const serviceList= computed(() =>[
//    {
//     isActive: false,
//     qrcode: require("../../assets/images/zl-z-1.png"),
//     name:  t('about.name1'),
//   },
//   {
//     isActive: false,
//     qrcode: require("../../assets/images/zl-z-2.png"),
//     name:  t('about.name2'),
//   },
//   {
//     isActive: false,
//     qrcode: require("../../assets/images/zl-z-3.png"),
//     name:  t('about.name3'),

//   },
//   {
//     isActive: false,
//     qrcode: require("../../assets/images/zl-z-4.png"),
//     name:  t('about.name4'),
//   }
// ])
// const originalServiceList = [
//   {
//     qrcode: require("../../assets/images/zl-z-1.png"),
//     name: t('about.name1'),
//   },
//   {
//     qrcode: require("../../assets/images/zl-z-2.png"),
//     name: t('about.name2'),
//   },
//   {
//     qrcode: require("../../assets/images/zl-z-3.png"),
//     name: t('about.name3'),
//   },
//   {
//     qrcode: require("../../assets/images/zl-z-4.png"),
//     name: t('about.name4'),
//   }
// ];
watch(locale, (newValue) => {
  if (newValue === 'zh') {
    serviceList.value = serviceList_cn.value
  } else if (newValue === 'en') {
    serviceList.value = serviceList_en.value
  }else{
    serviceList.value = serviceList_ru.value

  }
}, { immediate: true })

const ourserviceList = ref([
  {
    isActive: true,
    qrcode: require("../../assets/images/server-2.jpg"),
    name: 'aboutservice.service5'
  },
  {
    isActive: false,
    qrcode: require("../../assets/images/server-1.jpg"),
    name:''
  }
])
const getClass = (index, item) => {
  if (item.isActive === true) {
    return `isActive-${index}`;
  }
};
// const activeIndex = ref(-1); // 默认没有激活项

// // 3. 计算属性只负责“派生”出带有 isActive 状态的最终列表
// const serviceList = computed(() => {
//   return originalServiceList.map((item, index) => ({
//     ...item,
//     isActive: index === activeIndex.value
//   }));
// });

// 4. 鼠标悬停时，只需要修改索引即可，计算属性会自动更新
// const handleMouseOver = (index) => {
//   activeIndex.value = index;
// };
const handleMouseOver = (index) => {
  const newlist = serviceList.value.map((item) => {
    return { ...item, ...{ isActive: false } };
  });
  newlist[index].isActive = true;
  serviceList.value = newlist;
};
</script>
<style lang="scss" scoped>
.about-box {
  margin: 0 auto;
  width: 1280px;
}

.about-banner {
  width: 100%;
  position: relative;

  img {
    display: block;
    width: 100%;
  }

  p {
    width: 800px;
    position: absolute;
    text-align: center;
    left: 50%;
    margin-left: -400px;
    color: #fff;
  }

  .title {
    top: 180px;
    font-size: 40px;
    font-weight:600;
    letter-spacing:1px;
  }

  .subtitle {
    top: 250px;
    font-size: 18px;
    text-align: center;
    letter-spacing:1px;
  }

  .learn-btn {
    cursor: pointer;
    top: 350px;
    line-height:46px;
    padding:0 20px;
    display: flex;
    justify-content: space-between;
    height: 46px;
    font-size: 20px;
    position: absolute;
    text-align: center;
    left: 50%;
    border: 1px solid #fff;
    margin-left: -85px;
    color: #fff;
    border-radius: vars.$radius-4;

    &:hover {
      background-color: vars.$base-color;
      color: #fff;
      border: 1px solid vars.$base-color;
    }

    .topright-btn {
      margin-top: 13px;
    }
  }
}

.news-list {
  justify-items: center;
  justify-content: center;

  .left-list {
    flex: 1.4;
    padding: 10px 60px 60px 60px;

    h3 {
      margin: 20px auto;
      font-size: 32px;
    }

    .ul-list {
      display: flex;
      flex-direction: column;

      li {
        display: flex;
        flex-direction: row;

        .li-icon {
          display: block;
          width: 24px;
          height: 24px;
          background: url('../../assets/images/li-icon.svg') no-repeat left 6px;
        }

        .span-txt {
          margin-left: 10px;
          flex: 1;
          display: block;
          line-height: 32px;
          font-size: 16px;
        }
      }
    }
  }

  .right-list {
    flex: 2;
    border: 4px;

    img {
      width: 96%;
    }
  }
}

.news-wraper {
  margin-top: 30px;
  display: flex;
  gap: 50px;

  img {
    display: block;
    width: 700px;
    box-sizing: border-box;
    // border: 6px solid #f8f8f8;
  }

  .news-right-wraper {
    .news-right-title {
      margin-top: 40px;
      font-size: 32px;
      text-align: center;
    }

    .news-right-subtitle {
      margin-top: 40px;
      font-size: 16px;
      text-align: left;
      line-height: 32px;
      color: #000;
     
    }
  }
}

.bg-new-list {
  position: relative;

  img {
    width: 100%;
    box-sizing: border-box;
    // border: 6px solid #f8f8f8;
  }

  .text-bar {
    width: 100%;
    top: 35%;
    position: absolute;
    text-align: center;

    .title {
      color: #fff;
    }

    .subtitle {
      color: #fff;
    }
  }
}

.serviceList {
  display: flex;
  gap: 20px;
  justify-content: space-between;

  li {
    img {
      display: block;
      box-sizing: border-box;
      // border: 6px solid #f8f8f8;
    }

    .appscene {
      display: none
    }
  }

  .isActive-0:hover,
  .isActive-1:hover,
  .isActive-2:hover,
  .isActive-3:hover,
  .isActive-0,
  .isActive-1,
  .isActive-2,
  .isActive-3 {
    position: relative;

    .appscene {
      display: block;
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      color: #fff;
      box-sizing: border-box;
      background: rgba($color: vars.$base-color, $alpha: 0.8);

      .learn-txt {
        position: absolute;
        width: 100%;
        cursor: pointer;
        top: 45%;
        height: 36px;
        font-size: 24px;
        line-height: 36px;
        text-align: center;
        color: #fff;

        &:hover {
          background-color: #fff;
          color: vars.$base-color;
          border: #fff;
        }

        span {
          padding: 0 0px 10px 20px;
        }

        .topright-btn {
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }
  }
}

.serviceUIList {
  display: flex;
  gap: 0px;
  justify-content: space-between;

  li {
    img {
      width: 100%;
      display: block;
    
    }

    .appscene {
      display: none
    }
  }

  .isActive-0:hover,
  .isActive-1:hover,
  .isActive-0,
  .isActive-1 {
    position: relative;

    .appscene {
      display: block;
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      padding-top: 100px;
      color: #fff;
      box-sizing: border-box;
      background: rgba($color: vars.$base-color, $alpha: 0.8);

      .learn-txt {
        cursor: pointer;
        height: 36px;
        font-size: 20px;
        line-height: 36px;
        text-align: left;
        color: #fff;
        span {
          padding: 0 0px 10px 20px;
        }

        .topright-btn {
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }
  }
}
</style>